const AppPermissions = {
    AdminUsers: {
        Read: 'admin.users.read',
        Write: 'admin.users.write',
        Delete: 'admin.users.delete'
    },

    AdminTenants: {
        Read: 'admin.tenants.read',
        Write: 'admin.tenants.write',
        Delete: 'admin.tenants.delete',
    },

    AdminTemplates: {
        Read: 'admin.templates.read',
        Write: 'admin.templates.write',
        Delete: 'admin.templates.delete',
    },

    AdminDropDowns: {
        Read: 'admin.dropdowns.read',
        Write: 'admin.dropdowns.write',
        Delete: 'admin.dropdowns.delete',
    },

    AdminRoles: {
        Read: 'admin.roles.read',
        Write: 'admin.roles.write',
        Delete: 'admin.roles.delete'
    },

    AdminPermissionDefinitions: {
        Read: 'admin.permissiondefinitions.read',
        Write: 'admin.permissiondefinitions.write',
        Delete: 'admin.permissiondefinitions.delete'
    },

    ProjectsOverview: {
        Read: 'projects.overview.read',
        Create: 'projects.overview.create',
        Archive: 'projects.overview.archive'
    },

    ProjectsTabsInfo: {
        Read: 'projects.tabs.info.read',
        Write: 'projects.tabs.info.write'
    },

    ProjectsTabsNotice: {
        Read: 'projects.tabs.notice.read',
        Write: 'projects.tabs.notice.write'
    },

    ProjectsTabsProtocol: {
        Read: 'projects.tabs.protocol.read',
        Write: 'projects.tabs.protocol.write'
    },

    ProjectsTabsOrder: {
        Read: 'projects.tabs.order.read',
        Write: 'projects.tabs.order.write'
    },

    ProjectsTabsSiGePlan: {
        Read: 'projects.tabs.sigeplan.read',
        Write: 'projects.tabs.sigeplan.write'
    },

    ProjectsTabsLaterWorkPlanning: {
        Read: 'projects.tabs.laterworkplanning.read',
        Write: 'projects.tabs.laterworkplanning.write'
    },

    ProjectsTabsFinal: {
        Read: 'projects.tabs.final.read',
        Write: 'projects.tabs.final.write'
    },

    ProjectParticipants: {
        Read: 'projectparticipants.read',
        Write: 'projectparticipants.write',
        Delete: 'projectparticipants.delete'
    },

    ProjectFolder: {
        Read: 'projectfolder.read',
        Write: 'projectfolder.write'
    },

    MasterData: {
        Read: 'masterdata.read',
        Write: 'masterdata.write',
        Delete: 'masterdata.delete',
        Export: 'masterdata.export'
    },

    Map: {
        Read: 'map.read'
    }
};

export { AppPermissions };
export default AppPermissions;